import { createContext } from 'react';

export const ViewportValuesContext = createContext({
  viewport: {},
});

export default ViewportValuesContext;
